import { NavigateFunction } from 'react-router-dom';
import {
  Language,
  ReportRequestTypes,
  ServiceTypes,
  setStartTour,
  TypeOfUser,
} from '@pharmaplan/common';
import phoneIcon from '@pharmaplan/common/assets/icons/webUrgentCallIcon.svg';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import questionMarkIcon from '../../assets/svg/filledQuestionMark.svg';
import profileIcon from '../../assets/svg/profileIcon.svg';
import logOffIcon from '../../assets/svg/logOffIcon.svg';
import passwordChangeIcon from '../../assets/svg/passwordChangeIcon.svg';
import { ReactComponent as PhoneIcon } from '../../assets/svg/phoneIcon.svg';
import { ReactComponent as QuestionMarkIcon } from '../../assets/svg/questionMarkIcon.svg';
import { Constants } from '../../helpers/Constants';
import { ReactComponent as DashboardIcon } from '../../assets/svg/dashboardIcon.svg';
import { ReactComponent as MyReplacemnts } from '../../assets/svg/myReplacemnts.svg';
import aboutUsIcon from '../../assets/svg/aboutUsIcon.svg';
import privacyPolicyIcon from '../../assets/svg/privacyPolicyIcon.svg';
import termsOfUseIcon from '../../assets/svg/termsOfUse.svg';
import ReplayIcon from '../../assets/svg/replay.svg';

import strings from '../../localization';
import { logoutHandler } from '../../helpers/Functions';
import { store } from '../../store';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const stub = () => {};

const isSelfService = ServiceTypes.self === ServiceHandler.getService();
const {
  paths: { staticPages },
} = Constants;

const commonList = (userLang: Language) => {
  const { aboutUs, privacyPolicy, termsOfServices } = staticPages[userLang] ?? {};

  const arr = [
    {
      label: strings.aboutUs,
      icon: aboutUsIcon,
      key: 'about-us',
      onClick: () => {
        window.open(aboutUs, '_blank');
      },
    },
    {
      label: strings.privacyPolicy,
      icon: privacyPolicyIcon,
      key: 'privacy-policy',
      onClick: () => {
        window.open(privacyPolicy, '_blank');
      },
    },
  ];

  if (isSelfService) {
    arr.push({
      label: strings.termsOfService,
      icon: termsOfUseIcon,
      key: 'terms-service',
      onClick: () => {
        window.open(termsOfServices, '_blank');
      },
    });
  }

  return arr;
};
export const menuItems = (
  navigate: NavigateFunction,
  dispatch: typeof store.dispatch,
  userLang: Language,
) =>
  [
    {
      key: '1',
      label: strings.profile,
      icon: profileIcon,
      onClick: () => {
        navigate(Constants.paths.profile);
      },
    },
    {
      key: '2',
      label: strings.changePassword,
      icon: passwordChangeIcon,
      onClick: () => {
        navigate(Constants.paths.changePassword);
      },
    },
    ...commonList(userLang),
    {
      key: '3',
      label: strings.replayWalkthrough,
      icon: ReplayIcon,
      onClick: () => {
        navigate(Constants.paths.dashboard);
        dispatch(setStartTour(true));
      },
    },
    {
      key: '4',
      label: strings.faq,
      icon: questionMarkIcon,
      onClick: () => {
        navigate(Constants.paths.help);
      },
    },
    {
      key: '5',
      label: Constants.telephone,
      icon: phoneIcon,
      onClick: stub,
    },
    {
      key: '6',
      label: strings.logout,
      icon: logOffIcon,
      onClick: logoutHandler,
    },
  ];

export const adminMenuItems = (navigate: NavigateFunction) =>
  [
    {
      key: '1',
      label: strings.profile,
      icon: profileIcon,
      onClick: () => {
        navigate(Constants.paths.admin.profile);
      },
    },
    {
      key: '2',
      label: strings.changePassword,
      icon: passwordChangeIcon,
      onClick: () => {
        navigate(Constants.paths.admin.changePassword);
      },
    },
    {
      key: '3',
      label: strings.logout,
      icon: logOffIcon,
      onClick: logoutHandler,
    },
  ];

export const pharmacyAdminMenuItems = (
  navigate: NavigateFunction,
  userLang: Language,
) =>
  [
    {
      key: '1',
      label: strings.profile,
      icon: profileIcon,
      onClick: () => {
        navigate(Constants.paths.pharmacyAdmin.profile);
      },
    },
    {
      key: '2',
      label: strings.changePassword,
      icon: passwordChangeIcon,
      onClick: () => {
        navigate(Constants.paths.pharmacyAdmin.changePassword);
      },
    },
    ...commonList(userLang),
    {
      key: '4',
      label: strings.faq,
      icon: questionMarkIcon,
      onClick: () => {
        navigate(Constants.paths.pharmacyAdmin.help);
      },
    },
    {
      key: '5',
      label: Constants.telephone,
      icon: phoneIcon,
      onClick: stub,
    },
    {
      key: '3',
      label: strings.logout,
      icon: logOffIcon,
      onClick: logoutHandler,
    },
  ];

export const reportItems = (
  navigate: NavigateFunction,
  userType: TypeOfUser,
) => {
  const pharmacyReportMenu = [
    {
      key: '1',
      label: strings.bookingReport,
      onClick: () => {
        navigate(Constants.paths.reports, {
          state: {
            type: ReportRequestTypes.booked,
            title: strings.bookingReport,
          },
        });
      },
    },
    {
      key: '2',
      label: strings.postedWorkshiftReport,
      onClick: () => {
        navigate(Constants.paths.reports, {
          state: {
            type: ReportRequestTypes.workshift,
            title: strings.postedWorkshiftReport,
          },
        });
      },
    },
  ];

  if (isSelfService) {
    pharmacyReportMenu.push({
      key: '1',
      label: strings.chargesReport,
      onClick: () => {
        navigate(Constants.paths.reports, {
          state: {
            type: ReportRequestTypes.payment,
            title: strings.chargesReport,
          },
        });
      },
    });
  }

  return userType === TypeOfUser.pharmacy
    ? pharmacyReportMenu : [
      {
        key: '1',
        label: strings.bookingReport,
        onClick: () => {
          navigate(Constants.paths.reports, {
            state: {
              type: ReportRequestTypes.booked,
              title: strings.bookingReport,
            },
          });
        },
      },
      {
        key: '2',
        label: strings.availableWorkshiftDisplayed,
        onClick: () => {
          navigate(Constants.paths.reports, {
            state: {
              type: ReportRequestTypes.workshift,
              title: strings.availableWorkshiftDisplayed,
            },
          });
        },
      },
      {
        key: '3',
        label: strings.requestedWorkshifts,
        onClick: () => {
          navigate(Constants.paths.reports, {
            state: {
              type: ReportRequestTypes.requested,
              title: strings.requestedWorkshifts,
            },
          });
        },
      },
      {
        key: '4',
        label: strings.availabilitesReports,
        onClick: () => {
          navigate(Constants.paths.reports, {
            state: {
              type: ReportRequestTypes.availability,
              title: strings.availabilitesReports,
            },
          });
        },
      },
      {
        key: '5',
        label: strings.incomeReport,
        onClick: () => {
          navigate(Constants.paths.incomeReport);
        },
      },
      {
        key: '6',
        label: strings.watchlistReport,
        onClick: () => {
          navigate(Constants.paths.reports, {
            state: {
              type: ReportRequestTypes.watchlist,
              title: strings.watchlistReport,
            },
          });
        },
      },
      {
        key: '7',
        label: strings.vacationReport,
        onClick: () => {
          navigate(Constants.paths.reports, {
            state: {
              type: ReportRequestTypes.vacation,
              title: strings.vacationReport,
            },
          });
        },
      },
    ];
};
export const langItems = (changeLang: (lang: string) => void) =>
  [
    {
      key: '1',
      label: strings.en,
      onClick: () => {
        changeLang('en');
      },
    },
    {
      key: '2',
      label: strings.fr,
      onClick: () => {
        changeLang('fr');
      },
    },
  ];

export const toolbarItems = (userType: TypeOfUser) => {
  const isPharmacy = userType === TypeOfUser.pharmacy;
  let pharmacyReplacementLabel = strings.myReplacementPharmacists;

  if (isSelfService) {
    pharmacyReplacementLabel = strings.myReliefProfessionals;
  }

  const myReplacementsLabel = isPharmacy
    ? pharmacyReplacementLabel
    : strings.pharmaciesServed;

  return [
    {
      key: '1',
      Icon: DashboardIcon,
      label: strings.dashboard,
      subPaths: [Constants.paths.mapDashboard],
      path: `${Constants.paths.calendarDashboard}`,
      id: 'dashboard',
    },
    {
      key: '2',
      Icon: MyReplacemnts,
      label: myReplacementsLabel,
      path: Constants.paths.myReplacements,
      subPaths: [Constants.paths.notes, Constants.paths.history],
      id: 'myReplacements',
    },
  ];
};

export const contactIcons = [
  {
    Icon: PhoneIcon,
  },
  { Icon: QuestionMarkIcon },
];
